import { render, staticRenderFns } from "./veStuCheckType.vue?vue&type=template&id=fd0239ec&scoped=true"
import script from "./veStuCheckType.vue?vue&type=script&lang=js"
export * from "./veStuCheckType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0239ec",
  null
  
)

export default component.exports